import moment from 'moment'
import constantes from '../constants';

/**
 *
 * @file Arquivo reservado para os helpers específicos do sistema.
 * Cada método que precisar ser disponibilizado publicamente deve estar devidamente declarado e exportado nesse arquivo.
*/


/**
 * Função apenas de teste
 */
const numberMap = {
    //Unidade
    0 : [''		//0
        ,'I' 	//1
        ,'II'	//2
        ,'III'	//3
        ,'IV'	//4
        ,'V'	//5
        ,'VI'	//6
        ,'VII'	//7
        ,'VIII'	//8
        ,'IX'	//9
    ]
    //Dezena
    ,1 : [
         ''		//10
        ,'X'	//10
        ,'XX'   //20
        ,'XXX'  //30
        ,'XL'   //40
        ,'L'    //50
        ,'LX'   //60
        ,'LXX'  //70
        ,'LXXX' //80
        ,'XC'   //90
    ]
    ,2 : [
        ''
        ,'C'	//100
        ,'CC'   //200
        ,'CCC'  //300
        ,'CD'   //400
        ,'D'    //500
        ,'DC'   //600
        ,'DCC'  //700
        ,'DCCC' //800
        ,'CM' 	//900
    ]
    ,3 : [
         ''
        ,'M' //1000
    ]
};

const regExpDate = /^(\d{4})-(\d{1,2})-(\d{1,2})/;

const romanos = (input) => {
    if(input == '') return'';

    var number = parseInt(input);

    if(number > 1999){
        return "número maximo '1999'";
    }


    //Descobre se é Unidade, Dezena, Centana, Milhar
    var orderNumber = Number(input).toString();
    var orderLength = orderNumber.length;


    var unidadeDezenaCentena = orderLength - 1;


    var newOrder = '';
    for(var i = unidadeDezenaCentena; i >= 0 ;i--){
        newOrder = newOrder + orderNumber.charAt(i);
    }

    var finalCast = '';
    for(let i = unidadeDezenaCentena; i >= 0 ;i--){
        var auxVar = parseInt(newOrder.charAt(i));
        finalCast = finalCast + numberMap[i][auxVar];
    }

    return finalCast;
}



const formatData = (value) => {
    return moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');
}

const formatDataBrasil = (value) => {
    return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
}

const formatDataHoraMinutoSegundo = (value) => {
    return moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
}

const formatHoraMinuto = (value) => {
    return moment(value, 'HH:mm:ss').format('HH:mm');
}

const formatHoraSegundo = (value) => {
    return moment(value, 'HH:mm').format('HH:mm:ss');
}

const exibirDocumento = (urlApi, hashDocumento, prefix = null) => {
    let url = `${urlApi}/api/v1/documentos/${hashDocumento}`;
    if(prefix){
        url += `?prefix=${prefix}`;
    }
    window.open(url,'_blank');
}

const exibirAnexo = (urlApi, anexo) => {
    let url = `${urlApi}/api/v1/documentos/${anexo.documento_anexo_ato.nome_minio}`;
    if(anexo.documento_anexo_ato.extensao === 'pdf' || anexo.documento_anexo_ato.extensao === 'txt'){        
        if(anexo.documento_anexo_ato.prefix){
            url += `?prefix=${anexo.documento_anexo_ato.prefix}`;
        }
        window.open(url);
    }else{
        url += '/download';
        if(anexo.documento_anexo_ato.prefix){
            url += `?prefix=${anexo.documento_anexo_ato.prefix}`;
        }
        window.location.href = url;
    }
}

const somenteNumeros = (e) => {
    var charCode = e.charCode ? e.charCode : e.keyCode;
    // charCode 8 = backspace
    // charCode 9 = tab
    if (charCode != 8 && charCode != 9) {
        // charCode 48 equivale a 0
        // charCode 57 equivale a 9
        if (charCode < 48 || charCode > 57) {
            e.preventDefault();
        }
    }
}

const confirmaExclusao = (el, message = 'Confirma a exclusão do registro.', title = 'Exclusão de registro', okVariant = 'danger', okTitle = 'EXCLUIR') => {
     return el.$bvModal.msgBoxConfirm(message,
            {
                title,
                size: 'sm',
                buttonSize: 'sm',
                okVariant,
                okTitle,
                cancelVariant: 'outline-secondary',
                cancelTitle: 'CANCELAR',
                hideHeaderClose: false,
                centered: true
            });
}

const confirmaVoltar = (el, message = 'Existem alterações que não foram salvas. Deseja mesmo sair ?', title = 'Dados não Salvos', okVariant = 'danger', okTitle = 'SIM',cancelTitle = 'NÃO',  hideHeaderClose = true) => {
    return el.$bvModal.msgBoxConfirm(message,
           {
               title,
               size: 'sm',
               buttonSize: 'sm',
               okVariant,
               okTitle,
               cancelVariant: 'outline-secondary',
               cancelTitle,
               hideHeaderClose,
               centered: true
           });
}

const validarEstadoCampo = (valor, acao) => {
    if( acao == 'view' ) {
        return null;
    }
    return (valor === ''  || valor === undefined || valor === null ) ? false : true;
}

const getTipoEdicao = (tipo) => {
    if(tipo === 'P'){
        return '1ª Edição'
    }else if(tipo === 'S'){
        return '2ª Edição'
    } else if(tipo === 'E'){
        return 'Edição Extra'
    }
}

const getOrdemTipoEdicao = (tipo) => {
    if(tipo === 'P'){
        return 1
    }else if(tipo === 'S'){
        return 2
    } else if(tipo === 'E'){
        return 3
    }
}

const getHoraAtual = () => {
    const data = new Date();
    let minutos = (data.getMinutes() < 10 ? '0' : '') + data.getMinutes();
    let hora = (data.getHours() < 10 ? '0' : '') + data.getHours();
    let horaAtual = hora + ':' + minutos;
    return horaAtual;
}

const bytesToSize = (bytes) => {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return 'n/a';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    if (i == 0) return bytes + ' ' + sizes[i];
    return (bytes / Math.pow(1024, i)) + ' ' + sizes[i];
}

const convertToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.replace(/^data:.+;base64,/, ''));
    reader.onerror = error => reject(error);
});


const showAlert =  (alert, variant, mensagens, time = 10) => {
    alert.variant = variant;
    alert.mensagens = Array.isArray(mensagens) ? mensagens : [mensagens];
    alert.exibir = true;

    if(time > 0){
       setTimeout(() => alert.exibir = false, time * 1000);
    }
}

const closeAlert = (alert) => {
    alert.exibir = false;
}


const getExtensaoArquivo = (filename) => {
    return '.' + filename.split('.').pop();
}

const validaExtensaoArquivo = (filename, extPermitidas) => {
    const extFile = getExtensaoArquivo(filename);
    return extPermitidas.find(function(ext){ return extFile.toLowerCase() == ext.toLowerCase(); });
}

const isMobile = () => {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
    } else {
        return false
    }
}

const scrollWindowToTop = () => {
    return window.scrollTo(0,0);
}

const scrollModalToTop = () => {
    return  document.getElementsByClassName('modal-body')[0].scrollTop = 0;
}

const verificaDataEdicaoMaiorAtual = (edicao) => {
    var publicacao = new Date(edicao.dt_publicacao + ' ' + edicao.hr_publicacao);
    var hoje = new Date();
    return (publicacao.getTime() > hoje.getTime());
}

async function getEnv() {
    try {
      let data = await fetch(`${constantes.BASE_URL}/env.json`, {
        mode: "no-cors",
      });            
      let result = data.json();      
      return result;
    } catch (err) {
      console.log(err);
    }
}

async function getVersion() {    
    try {
      let data = await fetch(`${constantes.BASE_URL}/version.json`, {
        mode: "no-cors",
      });
      let result = data.json();
      return result;
    } catch (err) {
      console.log(err);
    }
}



export default {regExpDate, romanos, formatData, formatDataBrasil,formatDataHoraMinutoSegundo, formatHoraMinuto, formatHoraSegundo,
                            exibirDocumento, exibirAnexo, somenteNumeros, confirmaExclusao, confirmaVoltar, validarEstadoCampo,
                            getTipoEdicao, getOrdemTipoEdicao, getHoraAtual, bytesToSize, convertToBase64, showAlert, closeAlert, getExtensaoArquivo,
                            validaExtensaoArquivo, isMobile, scrollWindowToTop, scrollModalToTop, verificaDataEdicaoMaiorAtual, getEnv, getVersion};
